import React, { useContext, useMemo, useState } from "react";
import { Context } from "../../../context/context";
import moment from "moment";
import DateRangePicker from "@wojtekmaj/react-daterange-picker/dist/DateRangePicker";

// import "./VolumeCovep.scss";
import { Button } from "@mui/material";
import LineChart from "../../../components/LineChart/LineChart";
import { getVolumeByCovep } from "../../../services/graphics-service";
import { formatGraphicVolumePerCovep } from "../../../utils/formatted-graphic-values";
import SelectInput from "../../../components/Select/SelectInput";

const lossJustification = [
  {
    id: 1,
    name: "Condição Comercial",
  },
  { id: 2, name: "Crédito" },
  { id: 3, name: "Entrega" },
  { id: 4, name: "Estocado" },
];

const justifyItems = [
  {
    id: 1,
    name: "Pedido dia p/ dia",
  },
  { id: 2, name: "Carga incompleta" },
  { id: 3, name: "Logística fechada no dia seguinte" },
  { id: 4, name: "Pedido após as 16h" },
  { id: 5, name: "Caminhão quebrado" },
];

const justifyCredit = [
  { id: 1, name: "Inadimplência" },
  { id: 2, name: "Pendência de documento" },
  { id: 3, name: "Falta assinatura de contrato " },
  { id: 4, name: "Atraso análise de crédito" },
  { id: 5, name: "Crédito 100% tomado" },
];

const VolumeCovep = () => {
  const { sidebar } = useContext(Context);
  const token = localStorage.getItem("token");
  const [selectedReason, setSelectedReason] = useState(1);
  const [justify, setJustify] = useState("");
  const [graphicValues, setGraphicValues] = useState({});
  const [showGraphic, setShowGraphic] = useState(false);
  const [dateValue, setDateValue] = useState([
    moment(new Date()).subtract(30, "day").toDate(),
    new Date(),
  ]);

  const justifyName = useMemo(() => {
    if ([1, 4].includes(selectedReason)) return null;
    if (selectedReason === 2)
      return justifyCredit.find((just) => just.id === justify).name;
    return justifyItems.find((j) => j.id === justify).name;
  }, [justify]);

  const getGraphicData = async () => {
    const result = await getVolumeByCovep(
      token,
      moment(dateValue[0]).format("YYYY-MM-DD"),
      moment(dateValue[1]).format("YYYY-MM-DD"),
      lossJustification.find((mot) => mot.id === selectedReason).name,
      justifyName
    );

    setGraphicValues(formatGraphicVolumePerCovep(result.data));

    setShowGraphic(true);
  };

  return (
    <main className={sidebar ? "container" : "container-full"}>
      <h1>Volume perdido por covep</h1>

      <div className="graphic-csv-container">
        <p>
          Favor escolher o motivo e o submotivo se houver para gerar o gráfico.
        </p>

        <DateRangePicker onChange={(e) => setDateValue(e)} value={dateValue} />
        <form className="form-container">
          <SelectInput
            value={selectedReason}
            name="Qual o motivo da perda?"
            setValue={setSelectedReason}
            selectValues={lossJustification}
          />

          {[3].includes(selectedReason) && (
            <SelectInput
              value={justify}
              name="Justifique"
              setValue={setJustify}
              selectValues={justifyItems}
            />
          )}

          {[2].includes(selectedReason) && (
            <SelectInput
              value={justify}
              name="Justifique"
              setValue={setJustify}
              selectValues={justifyCredit}
            />
          )}
        </form>

        <Button
          className="generate-btn"
          variant="contained"
          onClick={getGraphicData}
        >
          Gerar gráfico
        </Button>
      </div>

      {showGraphic && (
        <>
          <div
            style={{
              width: "80%",
              display: "flex",
              justifyContent: "center",
            }}
          >
            {showGraphic > 0 && (
              <h1>{`Total: ${graphicValues?.datasets?.[0]?.data?.reduce(
                (acc, el) => {
                  return acc + el;
                },
                0
              )}`}</h1>
            )}
          </div>
          <div className="graphic-container">
            <LineChart values={graphicValues} />
          </div>
        </>
      )}
    </main>
  );
};

export default VolumeCovep;
